import {components, GroupBase, OptionProps} from 'react-select'
import React from 'react'
import {MemoOptionIconButton} from 'module/Memo/component/MemoOptionIconButton'
import {DqElement} from 'module/Dq/searchDq'
import {css} from '@emotion/react'
import {HighlightedTextComponent} from 'component/HighlightedTextComponent'

const cssRoot = css`
	display: flex;
	align-items: center;
	justify-content: space-between;
`
const cssOption = css`
	padding: 6px;
`

export function CustomFieldSelectOption<Option extends { _specialFirstEntry?: boolean, memo?: boolean }, IsMulti extends boolean, GroupType extends GroupBase<Option> = GroupBase<Option>>({
	children,
	...props
}: OptionProps<Option, IsMulti, GroupType> & {
	selectProps: OptionProps<Option, IsMulti, GroupType>['selectProps'] & {
		dispatchMemoToggleAction?: (x?: DqElement) => void
	}
}) {
	let overrideProps;
	if (props.data._specialFirstEntry) {
		overrideProps = {
			isFocused: false,
			isSelected: false,
			className: 'HiddenSelectOption',
		}
	}
	let term = props.selectProps.inputValue
	if (term && typeof children === 'string') {
		children = <HighlightedTextComponent text={children} searchTerm={term}/>
	}
	return <components.Option<Option, IsMulti, GroupType> css={cssOption} {...props} {...overrideProps}>
		<div css={cssRoot}>
			<div>
				{children}
			</div>
			<MemoOptionIconButton dispatchMemoToggleAction={props.selectProps.dispatchMemoToggleAction} element={props.data}/>
		</div>
	</components.Option>
}